import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';
import { CONTACT_EMAIL } from '../constants/contact';

export default function TermsOfService() {
  return (
    <LegalPageLayout
      title="Termos de utilização"
      lastUpdated={new Date().toLocaleDateString('pt-PT', { year: 'numeric', month: 'long', day: 'numeric' })}
    >
      <h2>1. Acordo</h2>
      <p>
        Estes Termos de Utilização (&quot;Termos&quot;) regem o seu acesso e utilização dos sítios web, aplicações e
        serviços relacionados NeoDrive (em conjunto, os &quot;Serviços&quot;). Ao criar uma conta, aceitar
        eletronicamente ou utilizar os Serviços, concorda com estes Termos em seu nome ou em nome da organização que
        representa.
      </p>

      <h2>2. Elegibilidade e contas</h2>
      <p>
        Deve ter autoridade para vincular a sua organização se se registar em seu nome. É responsável por manter a
        confidencialidade das credenciais e por toda a atividade na sua conta. Notifique-nos prontamente de qualquer
        utilização não autorizada.
      </p>

      <h2>3. Os Serviços</h2>
      <p>
        A NeoDrive disponibiliza ferramentas para ajudar a gerir fluxos operacionais (por exemplo relatórios, faturação e
        geração de ficheiros de pagamento). As funcionalidades podem variar conforme o plano. Podemos modificar,
        suspender ou descontinuar partes dos Serviços com aviso razoável quando praticável.
      </p>

      <h2>4. Utilização aceitável</h2>
      <p>Concorda em não:</p>
      <ul>
        <li>Utilizar os Serviços em violação da lei ou de direitos de terceiros;</li>
        <li>Tentar obter acesso não autorizado a sistemas, dados ou outras contas;</li>
        <li>Introduzir malware, sobrecarregar infraestruturas ou interferir com outros utilizadores;</li>
        <li>Fazer engenharia inversa ou tentar extrair código-fonte exceto quando permitido por lei;</li>
        <li>Utilizar os Serviços para enviar comunicações em massa não solicitadas sem consentimento.</li>
      </ul>

      <h2>5. Dados do cliente</h2>
      <p>
        Mantém a titularidade dos dados que submete. Concede-nos uma licença para alojar, tratar e apresentar esses
        dados apenas para fornecer e melhorar os Serviços e conforme descrito na nossa Política de Privacidade. Declara
        que dispõe de todos os direitos e consentimentos necessários para submeter os dados que fornece.
      </p>

      <h2>6. Taxas e pagamento</h2>
      <p>
        Os planos pagos são faturados conforme a subscrição que selecionar. Podem aplicar-se impostos. A falta de
        pagamento pode resultar em suspensão ou rescisão. Níveis gratuitos ou períodos experimentais podem ser
        oferecidos sujeitos aos limites indicados.
      </p>

      <h2>7. Propriedade intelectual</h2>
      <p>
        A NeoDrive e os seus licenciadores detêm todos os direitos sobre os Serviços, marca e documentação. Exceto os
        direitos limitados expressamente concedidos, não lhe são transferidos outros direitos.
      </p>

      <h2>8. Exclusão de garantias</h2>
      <p>
        OS SERVIÇOS SÃO FORNECIDOS &quot;NO ESTADO EM QUE SE ENCONTRAM&quot; E &quot;CONFORME DISPONÍVEIS&quot;, SEM
        GARANTIAS DE QUALQUER TIPO, EXPRESSAS OU IMPLÍCITAS, INCLUINDO COMERCIALIZAÇÃO, ADEQUAÇÃO A UM FIM ESPECÍFICO E
        NÃO VIOLAÇÃO, ATÉ AO MÁXIMO PERMITIDO POR LEI.
      </p>

      <h2>9. Limitação de responsabilidade</h2>
      <p>
        ATÉ AO MÁXIMO PERMITIDO POR LEI, A NEODRIVE NÃO SERÁ RESPONSÁVEL POR QUAISQUER DANOS INDIRETOS, INCIDENTAIS,
        ESPECIAIS, CONSEQUENCIAIS OU PUNITIVOS, OU POR PERDA DE LUCROS, DADOS OU BOA VONTADE. A NOSSA RESPONSABILIDADE
        AGREGADA POR RECLAMAÇÊNCIAS DECORRENTES DOS SERVIÇOS NÃO EXCEDERÁ OS VALORES PAGOS POR SI À NEODRIVE PELOS
        SERVIÇOS NOS DOZE (12) MESES ANTERIORES AO EVENTO QUE DEU ORIGEM À RESPONSABILIDADE (OU, SE NÃO SE APLICAREM
        TAXAS, CEM EUROS (100 €)).
      </p>

      <h2>10. Indemnização</h2>
      <p>
        Defenderá e indemnizará a NeoDrive contra reclamações decorrentes dos seus dados, da sua utilização dos
        Serviços em violação destes Termos ou da violação da lei aplicável, sujeito à nossa notificação atempada e
        cooperação razoável.
      </p>

      <h2>11. Duração e rescisão</h2>
      <p>
        Estes Termos mantêm-se em vigor enquanto utilizar os Serviços. Podemos suspender ou rescindir o acesso por
        incumprimento ou risco. Pode deixar de utilizar os Serviços a qualquer momento. As disposições que por natureza
        devam subsistir manter-se-ão após a rescisão.
      </p>

      <h2>12. Lei aplicável</h2>
      <p>
        Salvo quando a lei local imperativa disponha de outro modo, estes Termos regem-se pelas leis de Portugal, sem
        consideração às normas de conflito de leis. Os tribunais com sede em Portugal terão jurisdição exclusiva,
        sujeitos às proteções imperativas do consumidor quando aplicável.
      </p>

      <h2>13. Alterações</h2>
      <p>
        Podemos atualizar estes Termos. Alterações materiais serão comunicadas de forma adequada (por exemplo por
        correio eletrónico ou aviso na aplicação). A utilização continuada após a data de entrada em vigor constitui
        aceitação dos Termos atualizados.
      </p>

      <h2>14. Contacto</h2>
      <p>
        Questões sobre estes Termos:{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </LegalPageLayout>
  );
}
